/**
 * i18n Configuration
 *
 * Initializes i18next with react-i18next for internationalization support.
 * Supports English (en) and Chinese (zh) locales across 10 namespaces:
 * common, nav, assets, errors, auth, alerts, compliance, judgements, sync, dashboard.
 *
 * Default language: English
 * Default namespace: common
 *
 * Usage: import '@/i18n' in main.tsx, then use useTranslation() hook.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import zhCommon from './locales/zh/common.json';
import enNav from './locales/en/nav.json';
import zhNav from './locales/zh/nav.json';
import enAssets from './locales/en/assets.json';
import zhAssets from './locales/zh/assets.json';
import enErrors from './locales/en/errors.json';
import zhErrors from './locales/zh/errors.json';
import enAuth from './locales/en/auth.json';
import zhAuth from './locales/zh/auth.json';
import enAlerts from './locales/en/alerts.json';
import zhAlerts from './locales/zh/alerts.json';
import enCompliance from './locales/en/compliance.json';
import zhCompliance from './locales/zh/compliance.json';
import enJudgements from './locales/en/judgements.json';
import zhJudgements from './locales/zh/judgements.json';
import enSync from './locales/en/sync.json';
import zhSync from './locales/zh/sync.json';
import enDashboard from './locales/en/dashboard.json';
import zhDashboard from './locales/zh/dashboard.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      nav: enNav,
      assets: enAssets,
      errors: enErrors,
      auth: enAuth,
      alerts: enAlerts,
      compliance: enCompliance,
      judgements: enJudgements,
      sync: enSync,
      dashboard: enDashboard,
    },
    zh: {
      common: zhCommon,
      nav: zhNav,
      assets: zhAssets,
      errors: zhErrors,
      auth: zhAuth,
      alerts: zhAlerts,
      compliance: zhCompliance,
      judgements: zhJudgements,
      sync: zhSync,
      dashboard: zhDashboard,
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false },
});

export default i18n;
